import { render, staticRenderFns } from "./licenseAgreement.vue?vue&type=template&id=3ec4818b&scoped=true&"
import script from "./licenseAgreement.vue?vue&type=script&lang=js&"
export * from "./licenseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./licenseAgreement.vue?vue&type=style&index=0&id=3ec4818b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4818b",
  null
  
)

export default component.exports